module.exports = __webpack_public_path__ + "static/media/background-mobile.66aee1e4.png";